module.exports = "<covance-side-nav [topLevelMenu]=\"topLevelMenu | async\"></covance-side-nav>"